import {Component, OnDestroy, OnInit, input} from '@angular/core';
import {Store} from '@ngrx/store';
import * as fromApp from '../../../store/app.reducers';
import {ProfileService} from '../../profile.service';
import * as fromProfile from '../../store/profile.reducers';
import {ChartService} from '../../chart.service';
import {Chart} from 'angular-highcharts';
import {Observable, Subscription} from 'rxjs';

@Component({
    selector: 'app-profile-media-week-day-chart',
    templateUrl: './profile-media-week-day-chart.component.html',
    styleUrls: ['./profile-media-week-day-chart.component.scss'],
    standalone: false
})
export class ProfileMediaWeekDayChartComponent implements OnInit, OnDestroy {

  readonly type = input<'post_count' | 'like' | 'comment' | 'reach'>(undefined);
  readonly title = input<string>(undefined);

  charts: Chart[];
  profileSubscription: Subscription;
  profileState: Observable<fromProfile.State>;

  constructor(
    private store: Store<fromApp.AppState>,
    private profileService: ProfileService
  ) { }

  ngOnInit() {
    this.profileState = this.store.select('profile');

    this.profileSubscription = this.store.select('profile').subscribe(
      (state: fromProfile.State) => {
        if (state.mediaAnalyze !== null) {
          this.renderChart(
            true,
            state.mediaAnalyze
          );

        }

      }
    );
  }

  renderChart(reset: boolean, stats: any) {
    if (reset) {
      this.charts = [];
    }
    this.charts.push(
      ChartService.getMediaByWeekDayMetricChart(stats, this.type())
    );
  }

  ngOnDestroy() {
    this.profileSubscription.unsubscribe();
  }

}
